// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import createReducer from '../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  errors: {
    email: null,
    password: null,
  },
  credential: {
    email: null,
    password: null,
  },
  commonError: null,
};

const loginReducer = createReducer(initialState, {
  [types.LOGIN_REQUEST](state, action) {
    return {
      ...state,
      email: action.email,
      password: action.password,
    };
  },
  [types.LOGIN_FIELD_CHANGE](state, payload) {
    return {
      ...state,
      credential: Object.assign({}, state.credential, { [payload.field]: payload.value }),
      commonError: null,
    };
  },
  [types.LOGIN_FAILED](state, action) {
    return {
      ...state,
      commonError: action.error,
    };
  },
  [types.LOGIN_ERRORS_CHANGE](state, payload) {
    return {
      ...state,
      errors: Object.assign(state.errors, { [payload.field]: payload.error })
    };
  },
  [types.RESET_COMMON_ERROR](state, action) {
    return {
      ...state,
      commonError: action.commonError,
    };
  },
});

export default loginReducer;
